import { LiveReactionEmojiType } from "@/types/graphql/partner.generated";

/** Те же пределы, что проверяет бэкенд (PlatformValidator). */
export const MIN_REACTION_EMOJIS = 1;
export const MAX_REACTION_EMOJIS = 8;

/**
 * Все эмодзи в порядке бэкенда (LIVE_REACTION_EMOJIS): в этом порядке они
 * показаны в сетке и сохраняются. Сгенерированный enum отсортирован по
 * алфавиту, поэтому список явный.
 */
export const ALL_REACTION_EMOJIS: readonly LiveReactionEmojiType[] = [
  LiveReactionEmojiType.HeartType,
  LiveReactionEmojiType.FireType,
  LiveReactionEmojiType.LaughType,
  LiveReactionEmojiType.ClapType,
  LiveReactionEmojiType.WowType,
  LiveReactionEmojiType.PartyType,
  LiveReactionEmojiType.HeartEyesType,
  LiveReactionEmojiType.AngryType,
  LiveReactionEmojiType.SadType,
  LiveReactionEmojiType.ThumbsUpType,
  LiveReactionEmojiType.ThumbsDownType,
  LiveReactionEmojiType.MuscleType,
  LiveReactionEmojiType.SoccerType,
  LiveReactionEmojiType.BoxingType,
  LiveReactionEmojiType.TrophyType,
  LiveReactionEmojiType.MindBlownType,
];

export const REACTION_EMOJI_GLYPHS: Record<LiveReactionEmojiType, string> = {
  [LiveReactionEmojiType.HeartType]: "❤️",
  [LiveReactionEmojiType.FireType]: "🔥",
  [LiveReactionEmojiType.LaughType]: "😂",
  [LiveReactionEmojiType.ClapType]: "👏",
  [LiveReactionEmojiType.WowType]: "😮",
  [LiveReactionEmojiType.PartyType]: "🎉",
  [LiveReactionEmojiType.HeartEyesType]: "😍",
  [LiveReactionEmojiType.AngryType]: "😡",
  [LiveReactionEmojiType.SadType]: "😢",
  [LiveReactionEmojiType.ThumbsUpType]: "👍",
  [LiveReactionEmojiType.ThumbsDownType]: "👎",
  [LiveReactionEmojiType.MuscleType]: "💪",
  [LiveReactionEmojiType.SoccerType]: "⚽",
  [LiveReactionEmojiType.BoxingType]: "🥊",
  [LiveReactionEmojiType.TrophyType]: "🏆",
  [LiveReactionEmojiType.MindBlownType]: "🤯",
};

/**
 * Переключить эмодзи в наборе панели. Результат в порядке сетки; последний
 * выбранный снять нельзя, девятый не добавляется.
 */
export function toggleReactionEmoji(
  selected: readonly LiveReactionEmojiType[],
  emoji: LiveReactionEmojiType
): LiveReactionEmojiType[] {
  const has = selected.includes(emoji);
  if (has && selected.length <= MIN_REACTION_EMOJIS) return [...selected];
  if (!has && selected.length >= MAX_REACTION_EMOJIS) return [...selected];
  const next = new Set(
    has ? selected.filter((item) => item !== emoji) : [...selected, emoji]
  );
  return ALL_REACTION_EMOJIS.filter((item) => next.has(item));
}
